<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.2497 17.2496V3.74951H6.74902"
      stroke="#0E0E22"
      stroke-opacity="0.4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.2496 6.74951H3.74902V20.2495H17.2496V6.74951Z"
      stroke="#0E0E22"
      stroke-opacity="0.4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
